import React from 'react';
import { Provider } from 'react-redux';
import WidgetHeading from './components/WidgetHeading';
import Collapse from './components/Collapse';

const getIconClasses = (prefs, showIcon, toggleCollapse) => {
	const iconClasses = [];
	const {
		widgetHeading,
		headingIconClasses,
		headingIconSize,
		headingIconStyle
	} = prefs;

	if (widgetHeading && showIcon) {
		iconClasses.push('ddc-icon');

		if (!toggleCollapse) {
			iconClasses.push(`ddc-icon-${headingIconStyle}`);
		}
		if (headingIconSize) {
			iconClasses.push(`ddc-icon-size-${headingIconSize}`);
		}
		if (headingIconClasses) {
			iconClasses.push(headingIconClasses);
		}
	}

	return iconClasses;
};

const getHeadingClasses = (prefs, deviceType, toggleCollapse) => {
	const headingClasses = [];
	const { headingSize, headingStyles } = prefs;

	headingClasses.push('widget-heading');

	if (deviceType === 'MOBILE') {
		headingClasses.push('ddc-heading');
	}
	if (headingSize) {
		headingClasses.push(headingSize);
	}
	if (headingStyles) {
		headingClasses.push(`ddc-heading-${headingStyles}`);
	}
	if (toggleCollapse) {
		headingClasses.push('collapse-heading');
	}

	return headingClasses;
};

export const getWidgetComponents = (Widget, store, widgetId) => {
	const state = store.getState();
	const prefs = state.prefs || {};
	const toggleCollapse =
		(prefs.widgetHeading && prefs.toggleCollapse === 'true') || false;
	const showIcon = prefs.headingIconStyle ? true : toggleCollapse;

	return (
		<Provider store={store}>
			<React.Fragment>
				<WidgetHeading
					HeadingTag={prefs.headingTag}
					headingText={prefs.widgetHeading}
					widgetId={widgetId}
					toggleCollapse={toggleCollapse}
					showIcon={showIcon}
					headingClasses={getHeadingClasses(
						prefs,
						state.requestData.deviceType,
						toggleCollapse
					)}
					iconClasses={getIconClasses(
						prefs,
						showIcon,
						toggleCollapse
					)}
				/>
				<Collapse id={widgetId} toggleCollapse={toggleCollapse}>
					<Widget />
				</Collapse>
			</React.Fragment>
		</Provider>
	);
};



// WEBPACK FOOTER //
// ./src/ws-scripts/widget-components.jsx